<template>
  <div class="col mt-5">
    <div class="row" style="margin: 20px">
      <input id="date" />
    </div>
  </div>
</template>

<script>
require("./datepicker.min.js"); // depend on your folder structure;
export default {
  mounted() {
    console.log($("#date"));
    $("#date").datepicker();
  },
};
</script>
